<nav class="navbar fixed-top navbar-expand-sm navbar-light bg-light border-bottom">
    <div class="container">
        <span class="navbar-brand mb-0">
            <a routerLink="/home" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
                <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="82" height="41" viewBox="0 0 1019 454">
                    <path d="M282 216.5V334h202v-35H317v-69l77.8-.2 77.7-.3.3-17.3.2-17.2H318.3c-1 0-1.3-6.9-1.3-31s.3-31 1.3-31c.6 0 37.4-.1 81.7-.3l80.5-.2.3-16.8.2-16.7H282v117.5zM540.3 99.8l-20.3.2v130h164v69H520v35h199V195.1h-79.7c-43.9-.1-80.8-.1-82-.1H555v-62h84.3l79.7-.1V99l-79.2.2c-43.6.2-88.4.4-99.5.6zM761 216.5V334h204v-35H797v-83c0-65.7.3-83 1.3-83h83.3c69.7 0 82.3-.2 82.7-1.4.3-.8.6-8.4.6-17V99H761v117.5zM106.1 101c-.4.3-10.9 24.3-23.4 53.5-12.4 29.1-32.8 76.8-45.3 106-12.4 29.1-24.6 57.6-27 63.3L6.1 334l20.5-.2 20.5-.3L57.5 309c17.8-42.5 60.3-143.9 66.3-158.2 3.1-7.6 5.9-13.8 6.2-13.8.3 0 11.3 25.8 24.5 57.3 40.4 96.4 58.3 138.8 58.7 139.3.3.2 9.5.3 20.6.2l20-.3-4.3-10c-4.3-9.9-78.7-184.2-89.3-209-3-7.2-5.6-13.1-5.7-13.3-.4-.4-47.7-.7-48.4-.2z" />
                </svg>
            </a>
        </span>
        <button class="navbar-toggler no-print" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0 ">
                <li class="nav-item no-print">
                    <a routerLink="/home" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" class="nav-link" ariaCurrentWhenActive="page" translate>My Forms</a>
                </li>
                @if(userService.canReviewHR) {
                <li class="nav-item no-print">
                    <a routerLink="/hr-review" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" class="nav-link" ariaCurrentWhenActive="page" translate>For HR approval</a>
                </li>
                }
                @if(userService.canReviewEHS) {
                <li class="nav-item no-print">
                    <a routerLink="/ehs-review" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" class="nav-link" ariaCurrentWhenActive="page" translate>For EHS approval</a>
                </li>
                }
                @if(userService.canReviewForms) {
                <li class="nav-item no-print">
                    <a routerLink="/approved" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" class="nav-link" ariaCurrentWhenActive="page" translate>Approved forms</a>
                </li>
                <li class="nav-item no-print">
                    <a routerLink="/all" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" class="nav-link" ariaCurrentWhenActive="page" translate>All forms</a>
                </li>
                }
            </ul>
            @if(isAuthenticated$ | async) {
            <ul class="navbar-nav">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">{{email}}</a>
                    <ul class="dropdown-menu">
                        <li><button class="dropdown-item" (click)="logout()">Logout</button></li>
                    </ul>
                </li>
            </ul>
            } @else {
            <button class="nav-item btn btn-link text-white" (click)="login()">Log in</button>
            }
        </div>
    </div>
</nav>